import CameraPositionSpriteModel from "../../models/standard/CameraPositionSpriteModel";

export function serializeCameraPositionSprite(sprite: CameraPositionSpriteModel) {
  return {
    id: sprite.id,
    position: {
      x: sprite.position.x,
      y: sprite.position.y,
      z: sprite.position.z,
    },
    spaceUuid: sprite.spaceUuid ?? null,
  };
}
